import "core-js/modules/es.error.cause.js";
export default {
  props: {
    containerVisible: {
      type: Boolean,
      default: false
    },
    tableMark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      containerForm: {
        rowNum: 1,
        tableHeaderRowNum: 1,
        columnNum: 3,
        type: 'table',
        tableType: 'increment',
        tableUsage: 'control',
        id: -1
      }
    };
  },
  computed: {
    containerRules() {
      return {
        columnNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value < 3 || value > 9) {
              callback(new Error(this.$t('列输入无效,请重新输入')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        rowNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value < 1 || value > 50) {
              callback(new Error(this.$t('行输入无效,请重新输入')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    maxTabHeaderNum() {
      if (this.containerForm.tableType === 'increment') {
        return 100;
      } else if (this.containerForm.tableType === 'fixed') {
        return this.containerForm.rowNum - 1 > 0 ? this.containerForm.rowNum - 1 : 1;
      } else {
        return 100;
      }
    }
  },
  watch: {
    'containerForm.tableType': {
      handler(val) {
        if (val) {
          this.containerForm.rowNum = val === 'increment' ? 1 : 2;
        }
      }
    },
    containerVisible(val) {
      if (val) {
        this.containerForm = {
          rowNum: 1,
          tableHeaderRowNum: 1,
          columnNum: 3,
          type: 'table',
          tableType: 'increment',
          tableUsage: 'control',
          id: -1
        };
      }
    }
  },
  methods: {
    init() {
      this.containerVisible = true;
    },
    newContainerOk() {
      this.$refs['containerForm'].validate(valid => {
        if (valid) {
          this.containerForm.mark = this.tableMark;
          sessionStorage.setItem('tableInitInfo', JSON.stringify(this.containerForm));
          this.$emit('update:containerVisible', false);
          this.$emit('openDesign');
        }
      });
    },
    changeTableType(key) {
      this.containerForm.tableType = key;
      this.$nextTick(() => {
        this.$refs['containerForm'].validateField('rowNum');
      });
    },
    cancelNewContainer() {
      this.$emit('update:containerVisible', false);
    }
  }
};